import { useEffect, useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const EMPTY = { title: "", area: "", date_window: "", pay_usd: "", summary: "", customer_name: "", customer_phone: "", customer_address: "", customer_email: "", ticket_id: "", booking_id: "" };

/** Post a job; `draft` (from a ticket's "Post as job") prefills the form. */
export function JobForm({ draft, onCreated }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (draft) setF({ ...EMPTY, ...draft }); }, [draft]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/admin/jobs", { ...f, pay_usd: Number(f.pay_usd || 0) });
      toast.success(`Posted ${r.data.job_id} — signed techs are being emailed`);
      setF(EMPTY);
      onCreated?.(r.data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't post the job");
    } finally { setBusy(false); }
  };

  const inp = "dg-input w-full mt-1 py-1.5 text-sm";
  return (
    <form onSubmit={submit} className="dg-card rounded-xl p-5 space-y-3" data-testid="job-form">
      <div className="dg-eyebrow">Post an on-site job</div>
      <p className="text-xs text-slate-400">Techs see title, area, window, pay and summary. Customer details stay hidden until you assign someone.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        <label className="text-xs text-slate-400 sm:col-span-2">Title<input className={inp} value={f.title} onChange={set("title")} required minLength={3} placeholder="Mount 65” TV + hide cables" data-testid="job-title" /></label>
        <label className="text-xs text-slate-400">Area (public)<input className={inp} value={f.area} onChange={set("area")} required placeholder="Culver City 90230" data-testid="job-area" /></label>
        <label className="text-xs text-slate-400">Date window<input className={inp} value={f.date_window} onChange={set("date_window")} placeholder="Sat Jun 14, 10am–2pm" data-testid="job-date-window" /></label>
        <label className="text-xs text-slate-400">Pay to tech ($)<input className={inp} value={f.pay_usd} onChange={set("pay_usd")} inputMode="decimal" placeholder="120" data-testid="job-pay" /></label>
        <label className="text-xs text-slate-400 sm:col-span-2">Summary (public)<textarea className={`${inp} min-h-[70px]`} value={f.summary} onChange={set("summary")} maxLength={2000} placeholder="What needs doing, parts on hand, parking notes…" data-testid="job-summary" /></label>
      </div>
      <div className="dg-eyebrow pt-2">Customer (private until assigned)</div>
      <div className="grid sm:grid-cols-2 gap-3">
        <label className="text-xs text-slate-400">Name<input className={inp} value={f.customer_name} onChange={set("customer_name")} data-testid="job-customer-name" /></label>
        <label className="text-xs text-slate-400">Phone<input className={inp} value={f.customer_phone} onChange={set("customer_phone")} data-testid="job-customer-phone" /></label>
        <label className="text-xs text-slate-400 sm:col-span-2">Address<input className={inp} value={f.customer_address} onChange={set("customer_address")} data-testid="job-customer-address" /></label>
        <label className="text-xs text-slate-400">Email<input className={inp} value={f.customer_email} onChange={set("customer_email")} data-testid="job-customer-email" /></label>
        <label className="text-xs text-slate-400">Ticket / booking ref<input className={inp} value={[f.ticket_id, f.booking_id].filter(Boolean).join(" · ")} readOnly placeholder="— none —" data-testid="job-ref" /></label>
      </div>
      <button type="submit" disabled={busy} className="dg-btn-primary rounded-full px-5 py-2 text-sm inline-flex items-center gap-2 disabled:opacity-50" data-testid="job-post-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Post job & notify techs
      </button>
    </form>
  );
}
